/* The sections of the panel. Every row carries the name of its icon — the drawings themselves
   live in components/Icon.js, so the sidebar and the mobile bar draw the same set */
const data = [

    { section: "Обзор" },
    { name: "dashboard", text: "Dashboard", link: "/", icon: "dashboard" },
    { name: "lead", text: "Лиды", link: "/lead", icon: "lead" },

    { section: "Работа" },
    { name: "booking", text: "Записи", link: "/booking", icon: "booking" },
    { name: "queue", text: "Очередь", link: "/queue", icon: "queue" },
    { name: "organization", text: "Организации", link: "/organization", icon: "organization" },
    { name: "master", text: "Мастера", link: "/master", icon: "master" },
    { name: "category", text: "Категории", link: "/category", icon: "category" },
    { name: "services", text: "Услуги", link: "/services", icon: "service" },

    { section: "Клиенты" },
    { name: "user", text: "Пользователи", link: "/user", icon: "user" },
    { name: "review", text: "Отзывы", link: "/review", icon: "review" },
    { name: "support", text: "Жалобы", link: "/support", icon: "support" },
    { name: "inbox", text: "WhatsApp", link: "/inbox", icon: "phone" },

    { section: "Деньги" },
    { name: "transaction", text: "Транзакции", link: "/transaction", icon: "wallet" },
    { name: "promo", text: "Промокоды", link: "/promo", icon: "ticket" },

    { section: "Система" },
    { name: "notification", text: "Уведомления", link: "/notification", icon: "notification" },
    { name: "otp", text: "OTP логи", link: "/otp", icon: "otp" },
    { name: "admin", text: "Администраторы", link: "/admin", icon: "admin" },
    { name: "settings", text: "Настройки", link: "/settings", icon: "settings" }
]

export { data }
